module.exports = __webpack_public_path__ + "img/bf.0679153f.svg";